'use client'

import { ReactLenis } from 'lenis/react'
import RouteScrollManager from 'src/components/layout/RouteScrollManager'

const Lenis = ({ children }) => {
  return (
    <ReactLenis root options={{ anchors: false, lerp: 0.15 }}>
      <RouteScrollManager>{children}</RouteScrollManager>
    </ReactLenis>
  )
}

export default Lenis
